import React, { useState } from "react";
import { Container } from "react-bootstrap";
import axios from "axios";
import { APIurl } from "../../App";
import MSGDialogue from "../../components/Dialogue";
import ButtonInput from "../../common/ButtonInput";

export default function EAAdd() {

  const mentor = localStorage.getItem("email");

  const [symbols, setSymbols] = useState([]);
  const [symbolInput, setSymbolInput] = useState("");

  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);

  const [loginmsg, setLogingmsg] = useState("");
  const [colors, setColors] = useState("");
  const [logging, setLogging] = useState(false);
  const [diaglogueID] = useState("msgEA");

  /* ===== SYMBOLS ===== */
  const addSymbol = () => {
    if (!symbolInput.trim()) return;
    if (symbols.includes(symbolInput.toUpperCase())) return;

    setSymbols([...symbols, symbolInput.toUpperCase()]);
    setSymbolInput("");
  };

  const removeSymbol = (sym) => {
    setSymbols(symbols.filter(s => s !== sym));
  };

  /* ===== THUMBNAIL ===== */
  const handleThumbnail = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setThumbnail(file);
    setThumbnailPreview(URL.createObjectURL(file));
  };

  const removeThumbnail = () => {
    setThumbnail(null);
    setThumbnailPreview(null);
  };

  /* ===== SUBMIT ===== */
  const process = (e) => {
    e.preventDefault();

    setLogging(false);
    setLogingmsg("");

    const formData = new FormData();
    formData.append("cmd", "addrobot");
    formData.append("mentor", mentor);
    formData.append("name", document.getElementById("ea_name").value);
    formData.append("description", document.getElementById("ea_desc").value);
    formData.append("price", document.getElementById("ea_price").value);
    formData.append("colors", document.getElementById("ea_theme").value);
    formData.append("symbols", JSON.stringify(symbols));

    if (thumbnail) formData.append("thumbnail", thumbnail);
    if (document.getElementById("ea_file").files[0]) {
      formData.append("ea_file", document.getElementById("ea_file").files[0]);
    }

    axios.post(APIurl, formData)
      .then(res => {
        setLogingmsg(res.data.data);
        setColors(res.data.success ? "bg-success text-white" : "bg-danger text-white");
        setLogging(true);

        if (res.data.success) {
          e.target.reset();
          setSymbols([]);
          removeThumbnail();
        }
      })
      .catch(err => {
  if (err.response === undefined) {
    setLogingmsg("Upload failed: File is too large. Please upload a smaller EA file.");
  } else {
    setLogingmsg(err.response.data.data || "Server error occurred");
  }
  setColors("bg-danger text-white");
  setLogging(true);
});
  };

  return (
    <>
      {logging && <MSGDialogue msg={loginmsg} id={diaglogueID} colors={colors} />}

      <Container fluid className="d-flex flex-row mt-2 w-100">
        <div className="register-container mx-auto my-3 p-3 bg-white rounded">

          <h4 className="theme-color">Add EA Adviser</h4>
          <hr />

          <form onSubmit={process}>

            {/* EA NAME */}
            <input id="ea_name" className="form-control mb-2" placeholder="EA Name" required />

            {/* DESCRIPTION */}
            <textarea id="ea_desc" className="form-control mb-2" placeholder="EA Description" required />

            {/* PRICE */}
            <input id="ea_price" type="number" step="0.01" className="form-control mb-2" placeholder="EA Price" required />

            {/* THEME */}
            <label><b>EA Theme Color</b></label>
            <input id="ea_theme" type="color" className="form-control mb-3" />

            {/* THUMBNAIL */}
            <label><b>EA Thumbnail</b></label>
            <input type="file" accept="image/*" className="form-control mb-2" onChange={handleThumbnail} />

            {thumbnailPreview && (
              <div className="mb-2">
                <img src={thumbnailPreview} alt="preview" height="80" />
                <button type="button" className="btn btn-sm btn-danger ml-2" onClick={removeThumbnail}>
                  Remove
                </button>
              </div>
            )}

            {/* EA FILE */}
            <label><b>EA File</b></label>
            <input id="ea_file" type="file" className="form-control mb-3" required />

            {/* SYMBOLS */}
            <label><b>EA Symbols</b></label>
            <div className="d-flex mb-2">
              <input
                className="form-control"
                value={symbolInput}
                onChange={e => setSymbolInput(e.target.value)}
                placeholder="e.g. USDZAR"
              />
              <button type="button" className="btn btn-secondary ml-2" onClick={addSymbol}>
                Add
              </button>
            </div>

            <div className="mb-3">
              {symbols.map(sym => (
                <span key={sym} className="badge badge-primary mr-2">
                  {sym}
                  <i className="fa fa-times ml-1" onClick={() => removeSymbol(sym)} style={{ cursor: "pointer" }} />
                </span>
              ))}
            </div>

            <ButtonInput value="Add EA" active="btn-deactive my-2" />
          </form>
        </div>
      </Container>
    </>
  );
}
